module.exports = __webpack_public_path__ + "img/employeeEducation.73d30d4c.svg";